import { forwardRef } from 'react'
import { Button as MuiButton, Popover } from '@mui/material'
import { Button as ButtonV2 } from '@components/v2/button'
import * as css from './styles'
import { OverlayProps, ButtonProps } from './types'

export const ButtonWithOverlay = ({ children }) => children

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    popoverId,
    onClick,
    children,
    extendStyles,
    disabled = false,
    className,
    v2Enabled = false,
    variant = 'secondary',
  },
  ref,
) {
  return v2Enabled ? (
    <ButtonV2
      onClick={onClick}
      variant={variant}
      aria-describedby={popoverId}
      css={{ ...extendStyles }}
    >
      {children}
    </ButtonV2>
  ) : (
    <MuiButton
      ref={ref}
      aria-describedby={popoverId}
      variant="contained"
      size="small"
      disabled={disabled}
      disableRipple={true}
      disableElevation={true}
      className={className}
      css={{ ...css.muiButtonOverride, ...extendStyles }}
      onClick={onClick}
    >
      {children}
    </MuiButton>
  )
})

const Overlay = ({ sx = {}, popoverProps, children }: OverlayProps) => {
  const { anchorEl, anchorOrigin, transformOrigin, open, onClose, id, ...rest } = popoverProps
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={open}
      onClose={onClose}
      id={id}
      css={css.muiPopoverOverride}
      sx={{
        padding: 10,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Popover>
  )
}

ButtonWithOverlay.Button = Button
ButtonWithOverlay.Overlay = Overlay
